import { onDocumentReady } from 'Shared/resources/assets/app/js/helpers/domHelpers';

/**
 * Fix for Flash of unstyled content (FOUC)
 */
onDocumentReady(() => {
    document.body.style.visibility = 'visible';
});
